/* 🤖 this file was generated by script */
export const wiconCheckCircleBroken = {
  name: 'check_circle_broken',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 11.09V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3"/></svg>`,
};
